// extracted by mini-css-extract-plugin
module.exports = {"main":"WhySections_main_ibVjJ","content":"WhySections_content_kXbOe","mobile":"WhySections_mobile_4hChu","reasons":"WhySections_reasons_sg1A9","title":"WhySections_title_pqu9L"};